import React from "react";
import HomePage from "./Home/HomePage";

function Buyer() {
  return <HomePage />;
}

export default Buyer;
